import { ChangeEvent } from "react";

const ROOM_CODE_LENGTH = 6;

type RoomCodeInputProps = {
  id: string;
  value: string;
  disabled?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
  onComplete: (value: string) => void;
};

export function RoomCodeInput({
  id,
  value,
  disabled,
  placeholder,
  onChange,
  onComplete,
}: RoomCodeInputProps) {
  const update = (event: ChangeEvent<HTMLInputElement>) => {
    const roomCode = event.target.value
      .replace(/[^a-z0-9]/gi, "")
      .toUpperCase()
      .slice(0, ROOM_CODE_LENGTH);

    onChange(roomCode);
    if (roomCode.length === ROOM_CODE_LENGTH) onComplete(roomCode);
  };

  return (
    <input
      id={id}
      className="room-code-input"
      aria-label="Room code"
      placeholder={placeholder}
      value={value}
      onChange={update}
      disabled={disabled}
      required
      maxLength={ROOM_CODE_LENGTH}
      autoCapitalize="characters"
      autoComplete="off"
      spellCheck={false}
      inputMode="text"
    />
  );
}
